import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import { setAddVentilatorToTimeline } from '../store/quickActions.actions'
import { getVitalOptionsSelector } from '../../options/selectors'
import { IVitalOptionsState } from '../../options/store/options.types'

export function* setVentilatorQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate } = props
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  yield put({ type: 'ventilator/SET_DATE_TIME', date: currentDate, time: savedTimeString })
  yield put({ type: 'ventilator/SET_ASSESSED_BY', assessedBy: assessedByOption ? assessedByOption : null })
  yield put(setAddVentilatorToTimeline(true))
}

export function* setVentilatorQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_VENTILATOR_BUTTON_TYPE], setVentilatorQuickAction)
}
